export default function phoneNumber() {
  return {
    require: 'ngModel',
    link(scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push((inputValue) => {
        const transformedInput = inputValue
          ? inputValue.replace(/[^\d -]/g, '').replace(/^[^\d]+/, '')
          : null;

        if (transformedInput !== inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }

        return transformedInput;
      });
    },
  };
}
